import { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Ticker } from "@/components/layout/Ticker";
import { SiteFooter } from "@/components/SiteFooter";
import { LeadModal } from "@/components/LeadModal";

const LeadCtx = createContext(() => {});
export const useLead = () => useContext(LeadCtx);

export default function Layout() {
  const [target, setTarget] = useState(null);
  return (
    <LeadCtx.Provider value={setTarget}>
      <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
        <Navbar />
        <Ticker />
        <main className="flex-1"><Outlet /></main>
        <SiteFooter />
      </div>
      <LeadModal partner={target} onClose={() => setTarget(null)} />
    </LeadCtx.Provider>
  );
}
